
    <template>
        <div class="wrapper default">
            <div class="container">
                <component :is="componentName"
                           @redirectToConfirm="redirectToConfirm($event)"
                           @redirectToComplete="redirectToComplete($event)"></component>
            </div>
            <mini-footer></mini-footer>
        </div>
</template>

    <script>
        import { initialSite } from "../../../module/initialSite";
        import miniFooter from "../../sharedComponents/footerComponents/miniFooter.vue";
        import information from './information.vue';
        import confirm from './confirm.vue';
        import completed from './completed.vue'
    
        export default {
            data() {
                return {
                    componentName: 'information',
                }
            },
            components: {
                'mini-footer': miniFooter,
                'information': information,
                'confirm': confirm,
                'completed': completed
            },
            methods: {
                redirectToConfirm(data) {
                    this.$store.commit('setConfirm', data)
                    this.componentName = 'confirm';
                },
                redirectToComplete(data) {
                    this.componentName = 'completed';
                },
            },
            beforeMount() {
                initialSite(this);
            },
            beforeRouteEnter: (to, from, next) => {
                next(vm => {
                    if (isUserLogined())
                        vm.$router.push('/');
                });
            },
        }
    </script>

<style scoped>
</style>